"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authSlice = void 0;
var _toolkit = require("@reduxjs/toolkit");
const initialState = {
  isAuthorized: false,
  loginLoading: false,
  loginError: null,
  accessToken: '',
  refreshToken: '',
  logoutLoading: false,
  meLoading: false,
  user: null,
  sessionHasExpired: false
};
const authSlice = exports.authSlice = (0, _toolkit.createSlice)({
  name: 'auth',
  initialState,
  reducers: {
    processLogin: state => {
      state.loginLoading = true;
      state.loginError = null;
    },
    loginSuccess: (state, action) => {
      state.loginLoading = false;
      state.isAuthorized = true;
      state.accessToken = action.payload.access_token;
      state.refreshToken = action.payload.refresh_token;
      state.sessionHasExpired = false;
    },
    loginFailure: (state, action) => {
      state.loginLoading = false;
      state.loginError = action.payload;
    },
    processLogout: state => {
      state.logoutLoading = true;
    },
    logoutSuccess: state => {
      state.logoutLoading = false;
      state.isAuthorized = false;
      state.accessToken = '';
      state.refreshToken = '';
      state.sessionHasExpired = false;
    },
    logoutFailure: state => {
      state.logoutLoading = false;
    },
    processMe: state => {
      state.meLoading = true;
    },
    meSuccess: state => {
      state.meLoading = false;
      state.isAuthorized = true;
    },
    meFailure: state => {
      state.meLoading = false;
    },
    updateUser: (state, action) => {
      state.user = action.payload;
    },
    sessionHasExpired: state => {
      state.sessionHasExpired = true;
    }
  }
});